<h1 matDialogTitle>{{ 'Lock Dataset' | translate }}</h1>
<form class="ix-form-container" (submit)="onSubmit($event)">
  <p>
    {{ 'Lock Dataset {datasetName}?' | translate: { datasetName: dataset.name } }}
  </p>

  <ix-checkbox
    [formControl]="forceCheckbox"
    [label]="'Force unmount' | translate"
  ></ix-checkbox>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" [matDialogClose]="false">
      {{ 'Cancel' | translate }}
    </button>

    <button mat-button type="submit" color="primary" ixTest="lock">
      {{ 'Lock' | translate }}
    </button>
  </ix-form-actions>
</form>
